"use client"

import {
 useState, useCallback, useEffect, useMemo 
} from "react"
import {
  Paper,
  Box,
  Typography,
  IconButton,
  Tooltip,
  // Divider, // 2ECOMP: PremiumUI Refresh — removido (GroupsList legado desativado)
} from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import { useDispatch, useSelector, shallowEqual } from "react-redux"
import { useNavigate } from "react-router-dom"
import { ChevronDown, ChevronUp } from "lucide-react"
// 2ECOMP: PremiumUI Refresh — FolderIcon e SquareIcon removidos (GroupsList legado desativado)
import ViewListIcon from '@mui/icons-material/ViewList';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'; // 2ECOMP: PremiumUI Refresh — botão colapsar lista

import DeviceList from "./DeviceList"
// StatusCountersPanel removido - usando StatusChipsBar
import { StatusChipsBar } from "./components"
import { isDeviceMoving } from "../common/util/deviceColors"
// 2ECOMP: PremiumUI Refresh — BottomMenu removido do desktop (icon bar substituiu)
// Mobile BottomMenu está no App.jsx
import StatusCard from "../common/components/StatusCard"
import DeviceDetailPanel from "../common/components/DeviceDetailPanelPremium"
import { devicesActions, errorsActions } from "../store"
// 2ECOMP: PremiumUI Refresh — icon bar lateral
import PremiumIconBar from "./components/PremiumIconBar"

// Dialogs for DeviceDetailPanel actions
import AnchorDialog from "../common/components/AnchorDialog"
import RemoveAnchorDialog from "../common/components/RemoveAnchorDialog"
import LockUnlockConfirmationDialog from "../common/components/confirmation-dialog"
import RemoveDialog from "../common/components/RemoveDialog"
import { SuccessToast } from "../common/components/success-toast"
import { startStreaming } from "../common/util/cameras"
import usePersistedState from "../common/util/usePersistedState"
import EventsDrawer from "./EventsDrawer"
import MainToolbar from "./MainToolbar"
import { useTranslation } from "../common/components/LocalizationProvider"
import MainMap from "./MainMap"
import { useAttributePreference } from "../common/util/preferences"
import { useEffectAsync, useCatchCallback } from "../reactHelper";
import fetchOrThrow from "../common/util/fetchOrThrow";
// 2ECOMP: PremiumUI Refresh — TOPBAR_HEIGHT não mais usado na MainPage (TopBar oculta)
// import { TOPBAR_HEIGHT } from "../common/components/TopBar";
import {
  SIDEBAR_WIDTH,
  GAP,
  BOTTOM_PANEL_HEIGHT,
  WIDGET_POSITIONS,
  Z_INDEX,
  // 2ECOMP: PremiumUI Refresh — novas constantes
  ICON_BAR_WIDTH,
  ICON_BAR_COLLAPSED_WIDTH,
  DEVICE_LIST_WIDTH,
  SIDEBAR_TRANSITION,
} from "../common/theme/layout";
import { usePremiumTokens } from "../common/theme/usePremiumTokens"
import DeviceFollowPopup from "./components/DeviceFollowPopup" // 2ECOMP: follow popup

// 2ECOMP: PremiumUI Refresh — iconBarWidth e sidebarOpenWidth dinâmicos (collapse)
const useStyles = makeStyles()((theme, { tokens, deviceListOpen, iconBarWidth, sidebarOpenWidth }) => ({
  root: {
    height: "100%",
    backgroundColor: tokens?.surface?.base || theme.palette.background.paper,
  },
  // Mapa em tela cheia (por baixo do TopBar transparente)
  mapContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
  },
  sidebar: {
    // Glassmorphism alinhado com TopBar (blur 20px, opacidade 95%)
    backgroundColor: tokens?.glassmorphism?.heavy?.background || 'rgba(13, 17, 23, 0.95)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    pointerEvents: "none",
    display: "flex",
    flexDirection: "column",
    transition: "transform 0.3s ease, width 0.3s ease, left 0.3s ease",
    [theme.breakpoints.up("md")]: {
      position: "fixed",
      left: 0,
      top: 0, // 2ECOMP: PremiumUI Refresh — TopBar oculta na MainPage
      bottom: 0, // Alinhado ao bottom da tela
      height: "auto", // Altura automática baseada em top/bottom
      width: SIDEBAR_WIDTH,
      maxWidth: theme.dimensions.sidebarMaxWidth,
      minWidth: theme.dimensions.sidebarMinWidth,
      marginTop: GAP.SMALL, // Mantém espaço com TopBar
      zIndex: Z_INDEX.SIDEBAR,
    },
    [theme.breakpoints.down("md")]: {
      height: "100%",
      width: "100%",
    },
  },
  sidebarCollapsed: {
    [theme.breakpoints.up("md")]: {
      transform: `translateX(-${SIDEBAR_WIDTH}px)`, // Sem margem, só a largura
    },
  },
  header: {
    // Glassmorphism alinhado com TopBar e Sidebar (blur 20px, opacidade 95%)
    backgroundColor: tokens?.glassmorphism?.heavy?.background || 'rgba(13, 17, 23, 0.95)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    pointerEvents: "auto",
    zIndex: 6,
    color: tokens?.text?.primary || theme.palette.text.primary,
    "& .MuiIconButton-root": {
      color: tokens?.text?.primary || theme.palette.text.primary,
    },
    "& .MuiTypography-root": {
      color: tokens?.text?.primary || theme.palette.text.primary,
    },
  },
  footer: {
    pointerEvents: "auto",
    zIndex: 5,
  },
  middle: {
    flex: 1,
    display: "grid",
    minHeight: 0,
    // Ocupa todo o espaço restante (flex: 1 cuida disso)
    height: '100%',
    overflow: 'hidden',
  },
  contentMap: {
    pointerEvents: "auto",
    gridArea: "1 / 1",
  },
  contentList: {
    pointerEvents: "auto",
    gridArea: "1 / 1",
    zIndex: 4,
    display: 'flex',
    minHeight: 0,
  },
  // 2ECOMP: PremiumUI Refresh — medidas GPSWOX: floating panel com gap 8px
  deviceListPanel: {
    position: 'fixed',
    left: iconBarWidth + GAP.MEDIUM, // gap 8px entre sidebar e lista
    top: GAP.MEDIUM,
    bottom: GAP.MEDIUM,
    width: DEVICE_LIST_WIDTH,
    zIndex: Z_INDEX.DEVICE_LIST,
    // 2ECOMP: PremiumUI Refresh — esconder completamente ao fechar
    transform: deviceListOpen ? 'translateX(0)' : `translateX(-${sidebarOpenWidth + GAP.MEDIUM}px)`,
    transition: SIDEBAR_TRANSITION,
    backgroundColor: tokens?.glassmorphism?.heavy?.background || 'rgba(13, 17, 23, 0.95)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    borderRadius: 10, // .625rem GPSWOX
    overflow: 'hidden',
    // 2ECOMP: PremiumUI Refresh — shadow GPSWOX
    boxShadow: '0 5px 15px rgba(0,0,0,0.08), 0 15px 35px rgba(60,66,87,0.12), 0 2px 9px rgba(0,0,0,0.15)',
    display: 'flex',
    flexDirection: 'column',
    pointerEvents: 'auto',
  },
  groupList: {
    width: "100%",
    padding: 0,
  },
  // StatusCard posicionado no topo do mapa, ao lado da sidebar (estilo MettaX)
  // 2ECOMP: PremiumUI Refresh — left dinâmico baseado em deviceListOpen
  // 2ECOMP: PremiumUI Refresh — medidas GPSWOX: gap 8px
  statusCardWrapper: {
    position: "fixed",
    zIndex: Z_INDEX.STATUS_CARD,
    transition: `left 300ms cubic-bezier(0.4, 0, 0.2, 1), top 0.3s ease`,
    [theme.breakpoints.up("md")]: {
      left: deviceListOpen
        ? sidebarOpenWidth + GAP.MEDIUM
        : iconBarWidth + GAP.MEDIUM,
      top: GAP.MEDIUM,
    },
  },
  statusCardWrapperDetailCollapsed: {
    // Sem ajuste extra - StatusCard fica no topo independente do DetailPanel
  },
  // StatusCountersPanel - positioned next to sidebar
  statusCountersPanel: {
    position: "fixed",
    zIndex: Z_INDEX.WIDGETS,
    [theme.breakpoints.up("md")]: {
      left: WIDGET_POSITIONS.statusCounters.left,
      top: WIDGET_POSITIONS.statusCounters.top,
    },
    [theme.breakpoints.down("md")]: {
      display: "none", // Hidden on mobile
    },
  },
  // Inline status bar above device list - transparent para glassmorphism
  inlineStatusBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px 8px",
    borderBottom: `1px solid ${tokens?.border?.subtle || theme.palette.divider}`,
    backgroundColor: 'transparent',
    minHeight: 24,
    flexShrink: 0,
  },
  deviceCount: {
    fontSize: "0.7rem",
    color: tokens?.text?.secondary || theme.palette.text.secondary,
  },
  // Botão de collapse da sidebar (estilo GPSWOX com cantos diagonais)
  // Encaixado na borda direita da sidebar, parecendo parte dela
  // 2ECOMP: Posicionado no meio da altura da sidebar
  collapseButton: {
    position: "fixed",
    left: SIDEBAR_WIDTH, // Exatamente na borda direita da sidebar
    top: '50%', // Centralizado verticalmente
    transform: "translateX(0)",
    width: 20,
    height: 70,
    backgroundColor: tokens?.surface?.base || theme.palette.background.paper,
    border: `1px solid ${tokens?.border?.subtle || 'rgba(255,255,255,0.1)'}`,
    borderLeft: "none", // Sem borda no lado encaixado
    // Cantos diagonais sutis no lado direito
    clipPath: "polygon(0% 0%, 100% 8%, 100% 92%, 0% 100%)",
    borderRadius: "0 4px 4px 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxShadow: tokens?.shadows?.md || "2px 0 8px rgba(0,0,0,0.15)",
    zIndex: Z_INDEX.STATUS_CARD - 1, // Atrás do StatusCard mas visível
    // Mesma transição da sidebar para sincronizar animação
    transition: "transform 0.3s ease, background-color 0.2s ease",
    pointerEvents: "auto",
    "&:hover": {
      backgroundColor: tokens?.surface?.elevated || theme.palette.action.hover,
    },
    "& svg": {
      color: tokens?.text?.muted || theme.palette.grey[500],
      transition: "color 0.2s ease",
    },
    "&:hover svg": {
      color: tokens?.accent?.primary || theme.palette.primary.main,
    },
  },
  // Quando sidebar colapsada, botão move junto com a sidebar
  collapseButtonCollapsed: {
    // Move a mesma distância que a sidebar (sem margem)
    transform: `translateX(-${SIDEBAR_WIDTH}px)`,
    borderRadius: "0 4px 4px 0",
  },
  // Botão de collapse do DeviceDetailPanel (centralizado no topo)
  detailPanelCollapseButton: {
    position: "absolute",
    left: "50%",
    top: -20,
    transform: "translateX(-50%)",
    width: 70,
    height: 20,
    backgroundColor: tokens?.surface?.base || theme.palette.background.paper,
    border: `1px solid ${tokens?.border?.subtle || 'rgba(255,255,255,0.1)'}`,
    borderBottom: "none",
    // Trapézio: estreito no topo, largo na base (como na imagem de referência)
    clipPath: "polygon(10% 0%, 0% 100%, 100% 100%, 90% 0%)",
    borderRadius: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxShadow: tokens?.shadows?.sm || "0 -2px 8px rgba(0,0,0,0.1)",
    zIndex: Z_INDEX.DEVICE_DETAIL + 1,
    transition: "background-color 0.2s ease, transform 0.3s ease",
    "&:hover": {
      backgroundColor: tokens?.surface?.elevated || theme.palette.action.hover,
    },
    "& svg": {
      color: tokens?.text?.muted || theme.palette.grey[500],
      transition: "color 0.2s ease, transform 0.2s ease",
    },
    "&:hover svg": {
      color: tokens?.accent?.primary || theme.palette.primary.main,
    },
  },
  // Botão de collapse quando o painel está recolhido
  // Mantém apenas translateX - o botão acompanha o wrapper via position absolute
  detailPanelCollapseButtonCollapsed: {
    transform: "translateX(-50%)", // sem translateY extra - acompanha o painel
  },
  // 2ECOMP: PremiumUI Refresh — medidas GPSWOX: gap 8px + shadow
  deviceDetailPanelWrapper: {
    position: "fixed",
    zIndex: Z_INDEX.DEVICE_DETAIL,
    borderRadius: '10px 10px 0 0',
    overflow: 'hidden',
    // 2ECOMP: PremiumUI Refresh — shadow GPSWOX
    boxShadow: '0 5px 15px rgba(0,0,0,0.08), 0 15px 35px rgba(60,66,87,0.12), 0 2px 9px rgba(0,0,0,0.15)',
    transition: `transform 0.3s ease, left 300ms cubic-bezier(0.4, 0, 0.2, 1)`,
    [theme.breakpoints.up("md")]: {
      left: deviceListOpen
        ? sidebarOpenWidth + GAP.MEDIUM
        : iconBarWidth + GAP.MEDIUM,
      right: GAP.MEDIUM,
      bottom: GAP.MEDIUM,
    },
    [theme.breakpoints.down("md")]: {
      left: GAP.SMALL,
      right: GAP.SMALL,
      bottom: GAP.SMALL,
    },
  },
  // 2ECOMP: PremiumUI Refresh — usa BOTTOM_PANEL_HEIGHT (160px)
  deviceDetailPanelWrapperCollapsed: {
    transform: `translateY(${BOTTOM_PANEL_HEIGHT + GAP.SMALL}px)`,
  },
  // BottomMenu fixo no canto inferior esquerdo (estilo Traccar adaptado)
  // Ancorado permanentemente no fundo da sidebar - DeviceDetailPanel está à direita, não sobrepõe
  bottomMenuFixed: {
    position: "fixed",
    left: 0,
    bottom: 0, // Sempre no fundo - não precisa subir pois DeviceDetailPanel está à direita
    width: SIDEBAR_WIDTH,
    zIndex: Z_INDEX.SIDEBAR + 1, // Logo acima da sidebar, mas abaixo de tudo mais
    pointerEvents: "auto",
    backgroundColor: tokens?.surface?.base || theme.palette.background.paper,
    borderTop: `1px solid ${tokens?.border?.subtle || theme.palette.divider}`,
    transition: "transform 0.3s ease",
    willChange: "transform",
    [theme.breakpoints.down("md")]: {
      display: "none", // Mobile usa BottomMenu do App.jsx
    },
  },
  // Quando sidebar está colapsada, esconde junto
  bottomMenuSidebarCollapsed: {
    transform: `translateX(-${SIDEBAR_WIDTH}px)`,
  },
}))

const MainPage = () => {
  const tokens = usePremiumTokens()
  // 2ECOMP: PremiumUI Refresh — deviceListOpen precisa ser passado antes de ser declarado
  // Workaround: declarar estado antes do useStyles
  const [deviceListOpen, setDeviceListOpen] = usePersistedState("deviceListOpen", true)
  // 2ECOMP: PremiumUI Refresh — sidebar colapsável (50px/170px)
  const [sidebarCollapsed, setSidebarCollapsed] = usePersistedState("sidebarCollapsed", false)
  const iconBarWidth = sidebarCollapsed ? ICON_BAR_COLLAPSED_WIDTH : ICON_BAR_WIDTH
  // 2ECOMP: PremiumUI Refresh — medidas GPSWOX: inclui gap 8px entre sidebar e lista
  const sidebarOpenWidth = iconBarWidth + GAP.MEDIUM + DEVICE_LIST_WIDTH
  const { classes } = useStyles({ tokens, deviceListOpen, iconBarWidth, sidebarOpenWidth })
  const dispatch = useDispatch()
  const theme = useTheme()
  const navigate = useNavigate()
  const t = useTranslation()

  const desktop = useMediaQuery(theme.breakpoints.up("md"))
  const mapOnSelect = useAttributePreference("mapOnSelect", true)

  const selectedDeviceId = useSelector((state) => state.devices.selectedId)
  // 2ECOMP: shallowEqual NÃO bloqueia atualizações - apenas evita re-renders quando dados são idênticos
  const positions = useSelector((state) => state.session.positions, shallowEqual)
  const devices = useSelector((state) => state.devices.items)
  const followPopupDeviceIds = useSelector((state) => state.devices.followPopupDeviceIds) // 2ECOMP: follow popup
  const hiddenDeviceIds = useSelector((state) => state.devices.hiddenDeviceIds) // 2ECOMP: PremiumUI Refresh — devices ocultos

  // Persistir dispositivo selecionado no localStorage
  useEffect(() => {
    if (selectedDeviceId) {
      localStorage.setItem("selectedDeviceId", JSON.stringify(selectedDeviceId))
    } else {
      localStorage.removeItem("selectedDeviceId")
    }
  }, [selectedDeviceId])

  // Restaurar dispositivo selecionado ao carregar a página
  useEffect(() => {
    const savedDeviceId = localStorage.getItem("selectedDeviceId")
    if (savedDeviceId && !selectedDeviceId) {
      try {
        const deviceId = JSON.parse(savedDeviceId)
        // Só restaura se o dispositivo existir
        if (devices[deviceId]) {
          dispatch(devicesActions.selectId(deviceId))
        }
      } catch {
        // Ignore parsing errors
      }
    }
  }, [devices]) // Só executa quando devices mudam (carregamento inicial)

  // 2ECOMP: PremiumUI Refresh — painel de grupos legado DESATIVADO
  // Grupos agora são gerenciados inline no DeviceList (GroupHeader + GroupEditModal)
  // const [filteredGroups, setFilteredGroups] = useState([])
  // const [selectedGroupId, setSelectedGroupId] = useState(-1)
  // const [groupsLoading, setGroupsLoading] = useState(true)
  // const [groupsError, setGroupsError] = useState(null)
  // const [groupsExpanded, setGroupsExpanded] = usePersistedState("groupsExpanded", true)

  const [keyword, setKeyword] = usePersistedState("searchKeyword", "")
  const [filter, setFilter] = usePersistedState("filter", {
    statuses: [],
    groups: [],
    motionStates: [], // 'moving', 'stopped' - filters by motion attribute
  })
  const [filterSort, setFilterSort] = usePersistedState("filterSort", "")
  const [filterMap, setFilterMap] = usePersistedState("filterMap", false)
  const [searchFields, setSearchFields] = usePersistedState("searchFields", ["all"])
  const [devicesLoading, setDevicesLoading] = useState(true)

  // Legado mobile: manter devicesOpen e mapOnlyMode para path mobile intacto
  const [devicesOpen, setDevicesOpen] = usePersistedState("devicesOpen", true)
  const [mapOnlyMode, setMapOnlyMode] = usePersistedState("mapOnlyMode", false)
  const [eventsOpen, setEventsOpen] = usePersistedState("eventsOpen", false)
  const [detailPanelCollapsed, setDetailPanelCollapsed] = usePersistedState("detailPanelCollapsed", false)
  // 2ECOMP: PremiumUI Refresh — modo mapa full-screen
  const [mapFullscreen, setMapFullscreen] = usePersistedState("mapFullscreen", false)

  // DeviceDetailPanel dialogs state
  const [openAnchorDialog, setOpenAnchorDialog] = useState(false)
  const [openRemoveAnchorDialog, setOpenRemoveAnchorDialog] = useState(false)
  const [openLockUnlockDialog, setOpenLockUnlockDialog] = useState(false)
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false)
  const [commandLoading, setCommandLoading] = useState(false)
  const [cameraLoading, setCameraLoading] = useState(false)
  const [showSuccessToast, setShowSuccessToast] = useState(false)
  const [toastMessage, setToastMessage] = useState('')
  const [toastSeverity, setToastSeverity] = useState('success')

  // Estado para mostrar StatusCard (apenas quando clicado no mapa) - persistido
  const [showStatusCard, setShowStatusCard] = usePersistedState("showStatusCard", false)


  // 2ECOMP: PremiumUI Refresh — filtro de grupo legado DESATIVADO
  // useEffect(() => {
  //   setFilter((prev) => ({ ...prev, groups: selectedGroupId === -1 ? [] : [selectedGroupId] }))
  // }, [selectedGroupId])

  // Fechar lista no mobile ao selecionar um dispositivo (quando mapOnSelect=true)
  useEffect(() => {
    if (!desktop && mapOnSelect && selectedDeviceId) {
      setDevicesOpen(false)
      setMapOnlyMode(true)
    }
  }, [desktop, mapOnSelect, selectedDeviceId])

  const onEventsClick = useCallback(() => setEventsOpen(true), [setEventsOpen])

  // Handler para clique no marcador do mapa (mostra StatusCard)
  const handleMapMarkerClick = useCallback(() => {
    setShowStatusCard(true)
  }, [])

  // Fecha StatusCard quando dispositivo é desselecionado
  useEffect(() => {
    if (!selectedDeviceId) {
      setShowStatusCard(false)
    }
  }, [selectedDeviceId])

  // 2ECOMP: PremiumUI Refresh — keyboard shortcuts globais (desktop)
  useEffect(() => {
    if (!desktop) return undefined
    const handleGlobalKeyDown = (e) => {
      const tag = document.activeElement?.tagName
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return
      if (e.ctrlKey || e.metaKey || e.altKey) return

      if (e.key === 'Escape') {
        if (mapFullscreen) {
          setMapFullscreen(false)
        } else if (deviceListOpen) {
          setDeviceListOpen(false)
        }
      }
    }
    document.addEventListener('keydown', handleGlobalKeyDown)
    return () => document.removeEventListener('keydown', handleGlobalKeyDown)
  }, [desktop, deviceListOpen, setDeviceListOpen, mapFullscreen, setMapFullscreen])

  // 2ECOMP: PremiumUI Refresh — fullscreen via custom event do MapControlsPanel
  useEffect(() => {
    const handleToggle = () => setMapFullscreen((prev) => !prev);
    window.addEventListener('mapToggleFullscreen', handleToggle);
    return () => window.removeEventListener('mapToggleFullscreen', handleToggle);
  }, [setMapFullscreen]);

  // 2ECOMP: PremiumUI Refresh — aplicar class no body para CSS sync
  useEffect(() => {
    document.body.classList.toggle('map-fullscreen', mapFullscreen);
    return () => document.body.classList.remove('map-fullscreen');
  }, [mapFullscreen]);

  useEffectAsync(async () => {
    try {
      setDevicesLoading(true);
      const response = await fetchOrThrow('/api/devices');
      const devicesData = await response.json();
      if (Array.isArray(devicesData)) {
        // Usar ação update em vez de refresh para atualizações incrementais
        dispatch(devicesActions.update(devicesData));
      }
    } catch {
      // Error handling is done in fetchOrThrow
    } finally {
      setDevicesLoading(false);
    }

    const interval = setInterval(async () => {
      try {
        const response = await fetchOrThrow('/api/devices');
        const devicesData = await response.json();
        if (Array.isArray(devicesData)) {
          dispatch(devicesActions.update(devicesData));
        }
      } catch {
        // Error handling is done in fetchOrThrow
      }
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  // 2ECOMP: PremiumUI Refresh — fetch de grupos legado DESATIVADO
  // Grupos carregados via Redux (store/groups.js) pelo CachingController
  // useEffectAsync(async () => {
  //   setGroupsLoading(true)
  //   setGroupsError(null)
  //   try {
  //     const response = await fetchOrThrow('/api/groups')
  //     const data = await response.json()
  //     setFilteredGroups(data)
  //   } catch (error) {
  //     setGroupsError(error.message)
  //   } finally {
  //     setGroupsLoading(false)
  //   }
  // }, [])

  // 2ECOMP OPTIMIZED: Pré-computa índice de busca apenas quando devices mudam
  // Evita recalcular getAllValues para 3120 devices a cada keystroke
  const searchIndex = useMemo(() => {
    const index = new Map()
    const devicesObject = devices || {}

    // Função auxiliar para extrair todos os valores recursivamente
    const getAllValues = (obj) => {
      if (obj === null || obj === undefined) return ''
      if (typeof obj !== 'object') return String(obj)
      if (Array.isArray(obj)) return obj.map(getAllValues).join(' ')
      return Object.values(obj).map(getAllValues).join(' ')
    }

    Object.values(devicesObject).forEach((device) => {
      // Campos principais + todos os attributes em uma string lowercase
      const searchableText = [
        device.name,
        device.uniqueId,
        device.phone,
        device.model,
        device.contact,
        device.category,
        device.groupId,
        device.status,
        getAllValues(device.attributes),
      ].filter(Boolean).join(' ').toLowerCase()

      index.set(device.id, searchableText)
    })
    return index
  }, [devices]) // Só recalcula quando devices mudam

  // 2ECOMP OPTIMIZED: Filtro de devices SEM dependência de positions
  // Positions mudando não deve re-filtrar 3120 devices!
  const filteredDevices = useMemo(() => {
    const devicesObject = devices || {}
    let result = Object.values(devicesObject)

    // Keyword filter usando índice pré-computado (O(1) lookup)
    if (keyword && keyword.trim()) {
      const searchTerm = keyword.toLowerCase().trim()
      result = result.filter((device) => {
        const searchableText = searchIndex.get(device.id)
        return searchableText && searchableText.includes(searchTerm)
      })
    }

    // Status filter
    if (filter.statuses.length > 0) {
      result = result.filter(device => filter.statuses.includes(device.status))
    }

    // Group filter
    if (filter.groups.length > 0) {
      result = result.filter(device => filter.groups.includes(device.groupId))
    }

    // Sort
    if (filterSort) {
      result.sort((a, b) => {
        if (filterSort === "name") return a.name?.localeCompare(b.name)
        if (filterSort === "lastUpdate") return new Date(b.lastUpdate) - new Date(a.lastUpdate)
        return 0
      })
    }

    return result
  }, [devices, keyword, filter, filterSort, searchIndex]) // Removido positions!

  // 2ECOMP: Filtro de motion separado - só executa quando positions ou motionStates mudam
  // e apenas se o filtro estiver ativo
  const motionFilteredDevices = useMemo(() => {
    // Se não há filtro de motion, retorna filteredDevices direto
    if (!filter.motionStates || filter.motionStates.length === 0) {
      return filteredDevices
    }

    // Aplica filtro de motion nos devices já filtrados
    return filteredDevices.filter(device => {
      if (device.status !== 'online') return false
      const position = positions?.[device.id]
      const moving = isDeviceMoving(position)
      if (filter.motionStates.includes('moving') && moving) return true
      if (filter.motionStates.includes('stopped') && !moving && position) return true
      return false
    })
  }, [filteredDevices, filter.motionStates, positions])

  // 2ECOMP: Usa motionFilteredDevices se filtro de motion estiver ativo
  // Memoizado para evitar re-renders desnecessários do DeviceList
  const safeFilteredDevices = useMemo(() => {
    const finalDevices = (filter.motionStates && filter.motionStates.length > 0)
      ? motionFilteredDevices
      : filteredDevices
    return Array.isArray(finalDevices) ? finalDevices : []
  }, [filter.motionStates, motionFilteredDevices, filteredDevices])

  // Total device count (cheap - only depends on devices object)
  const totalDeviceCount = useMemo(() => Object.keys(devices || {}).length, [devices])

  // 2ECOMP: Otimizado - usa Set para O(1) lookup em vez de Array.includes O(n)
  const filteredDeviceIds = useMemo(() => {
    if (!filterMap || safeFilteredDevices.length === 0) return null
    return new Set(safeFilteredDevices.map((device) => device.id))
  }, [filterMap, safeFilteredDevices])

  // 2ECOMP: PremiumUI Refresh — Set para O(1) lookup de devices ocultos
  const hiddenSet = useMemo(
    () => (hiddenDeviceIds.length > 0 ? new Set(hiddenDeviceIds) : null),
    [hiddenDeviceIds],
  )

  const filteredPositions = useMemo(() => {
    const positionsObject = positions || {}
    const positionsArray = Object.values(positionsObject)

    // Se não há filtro nem ocultos, retorna todas as posições
    if (!filteredDeviceIds && !hiddenSet) return positionsArray

    return positionsArray.filter((position) => {
      // 2ECOMP: PremiumUI Refresh — excluir devices ocultos
      if (hiddenSet && hiddenSet.has(position.deviceId)) return false
      // Filtro de busca/status
      if (filteredDeviceIds && !filteredDeviceIds.has(position.deviceId)) return false
      return true
    })
  }, [positions, filteredDeviceIds, hiddenSet])

  const selectedPosition = filteredPositions.find(
    (position) => selectedDeviceId && position.deviceId === selectedDeviceId,
  )

  // 2ECOMP: PremiumUI Refresh — handlers de grupo legado DESATIVADOS
  // const handleSelectGroup = (groupId, event) => {
  //   event.stopPropagation()
  //   setSelectedGroupId(groupId)
  // }
  // const toggleGroupsExpanded = (event) => {
  //   event.stopPropagation()
  //   setGroupsExpanded(!groupsExpanded)
  // }

  // Audio functions for lock/unlock
  const playBlockSound = useCallback(() => {
    try {
      const audio = new Audio('./resources/bloqueio.wav')
      audio.volume = 0.5
      audio.play().catch(() => {
        const fallbackAudio = new Audio('./src/resources/bloqueio.wav')
        fallbackAudio.volume = 0.5
        fallbackAudio.play().catch(console.warn)
      })
    } catch (error) {
      console.warn('Erro no áudio de bloqueio:', error)
    }
  }, [])

  const playUnblockSound = useCallback(() => {
    try {
      const audio = new Audio('./resources/desbloqueio.wav')
      audio.volume = 0.5
      audio.play().catch(() => {
        const fallbackAudio = new Audio('./src/resources/desbloqueio.wav')
        fallbackAudio.volume = 0.5
        fallbackAudio.play().catch(console.warn)
      })
    } catch (error) {
      console.warn('Erro no áudio de desbloqueio:', error)
    }
  }, [])

  // Get blocked state from position
  const getBlockedState = useCallback(() => {
    if (!selectedPosition?.attributes) return false
    const blockedValue = selectedPosition.attributes.blocked
    if (typeof blockedValue === 'boolean') return blockedValue
    if (typeof blockedValue === 'string') return blockedValue.toLowerCase() === 'true' || blockedValue === '1'
    if (typeof blockedValue === 'number') return blockedValue === 1
    return false
  }, [selectedPosition])

  const isBlocked = getBlockedState()

  // Lock/Unlock handler
  const handleLockUnlockClick = useCallback(() => {
    if (commandLoading) return
    setOpenLockUnlockDialog(true)
  }, [commandLoading])

  const executeLockUnlock = useCallback(async () => {
    if (commandLoading || !selectedDeviceId) return
    setCommandLoading(true)
    const currentBlockedState = getBlockedState()
    const commandType = currentBlockedState ? 'engineResume' : 'engineStop'

    try {
      const response = await fetch('/api/commands/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json; charset=utf-8' },
        body: JSON.stringify({ deviceId: selectedDeviceId, type: commandType }),
      })

      if (response.ok) {
        if (commandType === 'engineStop') {
          setToastMessage(t('deviceBlocked') || 'Comando de bloqueio enviado com sucesso!')
          playBlockSound()
        } else {
          setToastMessage(t('deviceUnblocked') || 'Comando de desbloqueio enviado com sucesso!')
          playUnblockSound()
        }
        setToastSeverity('success')
        setShowSuccessToast(true)

        // Refresh devices after command
        const refreshAttempts = [1000, 3000, 5000]
        refreshAttempts.forEach((delay) => {
          setTimeout(async () => {
            try {
              const refreshResponse = await fetch('/api/devices')
              if (refreshResponse.ok) {
                const devicesData = await refreshResponse.json()
                dispatch(devicesActions.refresh(devicesData))
              }
            } catch (error) {
              console.error('Error refreshing devices:', error)
            }
          }, delay)
        })
      } else {
        throw new Error('Falha ao enviar comando')
      }
    } catch (error) {
      console.error('Erro ao executar bloqueio/desbloqueio:', error)
      setToastMessage(error.message || 'Erro ao executar comando')
      setToastSeverity('error')
      setShowSuccessToast(true)
      dispatch(errorsActions.push(error.message || 'Erro ao executar comando'))
    } finally {
      setCommandLoading(false)
      setOpenLockUnlockDialog(false)
    }
  }, [commandLoading, selectedDeviceId, getBlockedState, t, dispatch, playBlockSound, playUnblockSound])

  // Anchor handlers
  const handleAnchorClick = useCallback(() => {
    if (!selectedDeviceId || !devices[selectedDeviceId]) return
    const device = devices[selectedDeviceId]
    const hasAnchor = Boolean(device?.attributes?.hasAnchor)
    if (hasAnchor) {
      setOpenRemoveAnchorDialog(true)
    } else {
      setOpenAnchorDialog(true)
    }
  }, [selectedDeviceId, devices])

  // Camera handler
  const handleCameraClick = useCallback(async () => {
    if (!selectedDeviceId || !devices[selectedDeviceId] || cameraLoading) return
    const device = devices[selectedDeviceId]

    setCameraLoading(true)
    try {
      const channel = device.attributes?.devicePassword ? 0 : 1
      const resp = await startStreaming(device.uniqueId, device.attributes?.devicePassword, channel).then((r) => r.json())

      if (resp.data && /fail|error/i.test(resp.data._content)) {
        setToastMessage(resp.data._content)
        setToastSeverity('error')
        setShowSuccessToast(true)
      } else if (resp.data && resp.data._code !== '100') {
        setToastMessage(resp.data._msg)
        setToastSeverity('error')
        setShowSuccessToast(true)
      } else {
        setToastMessage(t('cameraStarted') || 'Camera iniciada com sucesso!')
        setToastSeverity('success')
        setShowSuccessToast(true)
      }
    } catch (error) {
      setToastMessage(error.message || 'Erro ao iniciar camera')
      setToastSeverity('error')
      setShowSuccessToast(true)
    } finally {
      setCameraLoading(false)
    }
  }, [selectedDeviceId, devices, cameraLoading, t])

  // Delete handler
  const handleDeleteClick = useCallback(() => {
    if (!selectedDeviceId) return
    setOpenRemoveDialog(true)
  }, [selectedDeviceId])

  const handleRemoveResult = useCallback(async (removed) => {
    setOpenRemoveDialog(false)
    if (removed) {
      try {
        const response = await fetch('/api/devices')
        const devicesData = await response.json()
        dispatch(devicesActions.refresh(devicesData))
        dispatch(devicesActions.selectId(null))
        setToastMessage(t('deviceDeleted') || 'Dispositivo removido com sucesso!')
        setToastSeverity('success')
        setShowSuccessToast(true)
      } catch {
        setToastMessage('Erro ao atualizar lista')
        setToastSeverity('error')
        setShowSuccessToast(true)
      }
    }
  }, [dispatch, t])

  // Create Geofence handler (same as StatusCard)
  const handleGeofence = useCatchCallback(async () => {
    if (!selectedPosition) return
    const newItem = {
      name: t('sharedGeofence'),
      area: `CIRCLE (${selectedPosition.latitude} ${selectedPosition.longitude}, 50)`,
    }
    const response = await fetchOrThrow('/api/geofences', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newItem),
    })
    const item = await response.json()
    await fetchOrThrow('/api/permissions', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ deviceId: selectedPosition.deviceId, geofenceId: item.id }),
    })
    navigate(`/settings/geofence/${item.id}`)
  }, [navigate, selectedPosition, t])

  // 2ECOMP: PremiumUI Refresh — GroupsList legado DESATIVADO
  // Grupos agora são gerenciados inline no DeviceList (GroupHeader + GroupEditModal)
  // Código preservado para referência futura — ver git history para versão completa
  /*
  const GroupsList = () => {
    if (groupsLoading) { return <Box sx={{ py: 1 }}><Typography variant="body2" sx={{ color: "text.secondary", fontSize: "0.75rem" }}>Loading...</Typography></Box> }
    if (groupsError) { return <Box sx={{ py: 1 }}><Typography variant="body2" sx={{ color: "error.main", fontSize: "0.75rem" }}>Error: {groupsError}</Typography></Box> }
    if (!filteredGroups || filteredGroups.length === 0) { return <Box sx={{ py: 1 }}><Typography variant="body2" sx={{ color: "text.secondary", fontSize: "0.75rem" }} /></Box> }
    const rootGroups = Array.isArray(filteredGroups) ? filteredGroups.filter((g) => g.groupId === 0) : Object.values(filteredGroups).filter((g) => g.groupId === 0)
    return (<> ... GroupsList JSX com FolderIcon, SquareIcon, ChevronUp/Down ... </>)
  }
  */

  return (
    <div className={classes.root}>
      {/* Mapa em tela cheia - por baixo do TopBar transparente */}
      {desktop && (
        <div className={classes.mapContainer}>
          <MainMap
            filteredPositions={filteredPositions}
            selectedPosition={selectedPosition}
            onEventsClick={onEventsClick}
            onMarkerClick={handleMapMarkerClick}
          />
        </div>
      )}
      {/* 2ECOMP: PremiumUI Refresh — Icon Bar fixa (desktop only) */}
      {/* 2ECOMP: PremiumUI Refresh — Icon Bar oculta em fullscreen */}
      {desktop && !mapFullscreen && (
        <PremiumIconBar
          onToggleList={() => setDeviceListOpen((prev) => !prev)}
          listOpen={deviceListOpen}
          onCommandsClick={() => {
            if (selectedDeviceId) navigate(`/settings/device/${selectedDeviceId}/command`)
          }}
          collapsed={sidebarCollapsed}
          onToggleCollapse={() => setSidebarCollapsed((p) => !p)}
        />
      )}

      {/* 2ECOMP: PremiumUI Refresh — Device List Panel lateral (desktop, escondido em fullscreen) */}
      {desktop && !mapFullscreen && (
        <div className={classes.deviceListPanel}>
          {/* Header: Toolbar (GroupsList legado removido — grupos inline no DeviceList) */}
          <Paper square elevation={3} className={classes.header} sx={{ pb: 1 }}>
            {/* 2ECOMP: PremiumUI Refresh — GroupsList legado DESATIVADO */}
            {/* <Box sx={{ px: 2, py: 0.5 }}><GroupsList /></Box> */}
            {/* <Divider sx={{ borderColor: tokens?.border?.subtle || theme.palette.divider }} /> */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ flex: 1 }}>
                <MainToolbar
                  filteredDevices={safeFilteredDevices}
                  devicesOpen={deviceListOpen}
                  setDevicesOpen={setDeviceListOpen}
                  mapOnlyMode={false}
                  setMapOnlyMode={() => {}}
                  keyword={keyword}
                  setKeyword={setKeyword}
                  filter={filter}
                  setFilter={setFilter}
                  filterSort={filterSort}
                  setFilterSort={setFilterSort}
                  filterMap={filterMap}
                  setFilterMap={setFilterMap}
                  searchFields={searchFields}
                  setSearchFields={setSearchFields}
                />
              </Box>
              {/* 2ECOMP: PremiumUI Refresh — botão colapsar lista igual GPSWOX */}
              <Tooltip title={t('sharedHide') || 'Ocultar'} placement="bottom">
                <IconButton
                  size="small"
                  onClick={() => setDeviceListOpen(false)}
                  sx={{ p: 0.5, mr: 0.5 }}
                >
                  <ChevronLeftIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          </Paper>
          {/* Inline Device Counter */}
          <Box className={classes.inlineStatusBar}>
            <Typography className={classes.deviceCount} sx={{ fontWeight: 600 }}>
              {safeFilteredDevices.length} de {totalDeviceCount} dispositivos
            </Typography>
          </Box>
          {/* Status Chips Bar */}
          <StatusChipsBar filter={filter} setFilter={setFilter} />
          {/* Device List */}
          <Box sx={{ flex: 1, overflow: "auto", minHeight: 0 }}>
            {devicesLoading ? (
              <div style={{ padding: '20px', textAlign: 'center', color: tokens?.text?.muted || '#888' }}>
                Carregando dispositivos...
              </div>
            ) : (
              <DeviceList
                devices={safeFilteredDevices}
                hasActiveFilter={!!(keyword || filter.statuses?.length > 0 || filter.groups?.length > 0 || filter.motionStates?.length > 0)}
              />
            )}
          </Box>
        </div>
      )}

      {/* 2ECOMP: PremiumUI Refresh — botão reabrir lista quando fechada (estilo GPSWOX) */}
      {desktop && !mapFullscreen && !deviceListOpen && (
        <Tooltip title={t('deviceTitle') || 'Dispositivos'} placement="right">
          <IconButton
            onClick={() => setDeviceListOpen(true)}
            sx={{
              position: 'fixed',
              left: iconBarWidth + GAP.MEDIUM,
              top: GAP.MEDIUM,
              zIndex: Z_INDEX.DEVICE_LIST,
              width: 36,
              height: 36,
              borderRadius: '10px',
              backgroundColor: tokens?.glassmorphism?.heavy?.background || 'rgba(13, 17, 23, 0.90)',
              backdropFilter: 'blur(12px)',
              WebkitBackdropFilter: 'blur(12px)',
              border: `1px solid ${tokens?.border?.subtle || 'rgba(255,255,255,0.08)'}`,
              color: tokens?.text?.secondary || '#9ca3af',
              boxShadow: tokens?.shadows?.md || '0 2px 8px rgba(0,0,0,0.2)',
              transition: SIDEBAR_TRANSITION,
              '&:hover': {
                backgroundColor: 'rgba(0, 212, 170, 0.15)',
                color: '#00d4aa',
              },
            }}
          >
            <ViewListIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      )}

      {/* Mobile: Sidebar legada (mantida intacta) */}
      {!desktop && (
      <div className={classes.sidebar}>
        {!mapOnlyMode && (
          <Paper square elevation={3} className={classes.header} sx={{ pb: 1 }}>
            {/* 2ECOMP: PremiumUI Refresh — GroupsList legado DESATIVADO (mobile) */}
            {/* <Box sx={{ px: 2, py: 0.5 }}><GroupsList /></Box> */}
            {/* <Divider sx={{ borderColor: tokens?.border?.subtle || theme.palette.divider }} /> */}
            <MainToolbar
              filteredDevices={safeFilteredDevices}
              devicesOpen={devicesOpen}
              setDevicesOpen={setDevicesOpen}
              mapOnlyMode={mapOnlyMode}
              setMapOnlyMode={setMapOnlyMode}
              keyword={keyword}
              setKeyword={setKeyword}
              filter={filter}
              setFilter={setFilter}
              filterSort={filterSort}
              setFilterSort={setFilterSort}
              filterMap={filterMap}
              setFilterMap={setFilterMap}
              searchFields={searchFields}
              setSearchFields={setSearchFields}
            />
          </Paper>
        )}
        <div
          className={classes.middle}
          style={mapOnlyMode ? { height: "100%" } : undefined}
        >
          <div className={classes.contentMap}>
            <MainMap
              filteredPositions={filteredPositions}
              selectedPosition={selectedPosition}
              onEventsClick={onEventsClick}
              onMarkerClick={handleMapMarkerClick}
            />
          </div>
          {devicesOpen && !mapOnlyMode && (
            <Paper
              square
              className={classes.contentList}
              sx={{
                bgcolor: tokens?.surface?.base || theme.palette.background.paper,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box className={classes.inlineStatusBar}>
                <Typography className={classes.deviceCount} sx={{ fontWeight: 600 }}>
                  {safeFilteredDevices.length} de {totalDeviceCount} dispositivos
                </Typography>
              </Box>
              <StatusChipsBar filter={filter} setFilter={setFilter} />
              <Box sx={{ flex: 1, overflow: "auto", minHeight: 0, paddingBottom: "70px" }}>
                {devicesLoading ? (
                  <div style={{ padding: '20px', textAlign: 'center', color: tokens?.text?.muted || '#888' }}>
                    Carregando dispositivos...
                  </div>
                ) : (
                  <DeviceList
                    devices={safeFilteredDevices}
                    hasActiveFilter={!!(keyword || filter.statuses?.length > 0 || filter.groups?.length > 0 || filter.motionStates?.length > 0)}
                  />
                )}
              </Box>
            </Paper>
          )}
        </div>
      </div>
      )}

      {/* Mobile: mapOnlyMode floating button */}
      {!desktop && mapOnlyMode && (
        <IconButton
          onClick={() => {
            setMapOnlyMode(false)
            setDevicesOpen(true)
          }}
          sx={{
            position: 'fixed',
            top: 16, // 2ECOMP: PremiumUI Refresh — TopBar oculta na MainPage
            left: 16,
            zIndex: 9999,
            backgroundColor: tokens?.surface?.glass || theme.palette.background.paper,
            color: tokens?.text?.primary || theme.palette.text.primary,
            boxShadow: tokens?.shadows?.lg || '0px 2px 10px rgba(0,0,0,0.2)',
            transition: 'all 0.3s ease',
            '&:hover': {
              backgroundColor: tokens?.surface?.elevated || theme.palette.action.hover,
              transform: 'scale(1.05)',
            },
            width: 48,
            height: 48,
          }}
        >
          <ViewListIcon fontSize="medium" />
        </IconButton>
      )}


      <EventsDrawer open={eventsOpen} onClose={() => setEventsOpen(false)} />

      {/* Mobile: StatusCard (popup flutuante) */}
      {!desktop && selectedDeviceId && (
        <StatusCard
          deviceId={selectedDeviceId}
          position={selectedPosition}
          onClose={() => dispatch(devicesActions.selectId(null))}
          desktopPadding={0}
        />
      )}

      {/* Desktop: StatusCard (escondido em fullscreen) */}
      {/* 2ECOMP: PremiumUI Refresh — left dinâmico + escondido em fullscreen */}
      {desktop && !mapFullscreen && showStatusCard && selectedDeviceId && (
        <div className={`${classes.statusCardWrapper} ${detailPanelCollapsed ? classes.statusCardWrapperDetailCollapsed : ''}`}>
          <StatusCard
            deviceId={selectedDeviceId}
            position={selectedPosition}
            onClose={() => setShowStatusCard(false)}
            desktopPadding={0}
            useExternalPosition
          />
        </div>
      )}

      {/* 2ECOMP: follow popup — popups isolados com mini-mapa */}
      {followPopupDeviceIds.map((id, idx) => (
        <DeviceFollowPopup key={id} deviceId={id} index={idx} />
      ))}

      {/* Desktop: DeviceDetailPanel (painel inferior, escondido em fullscreen) */}
      {/* 2ECOMP: PremiumUI Refresh — left dinâmico + escondido em fullscreen */}
      {desktop && !mapFullscreen && selectedDeviceId && devices[selectedDeviceId] && (
        <div className={`${classes.deviceDetailPanelWrapper} ${detailPanelCollapsed ? classes.deviceDetailPanelWrapperCollapsed : ''}`}>
          {/* Botão de collapse do DeviceDetailPanel */}
          <div
            className={`${classes.detailPanelCollapseButton} ${detailPanelCollapsed ? classes.detailPanelCollapseButtonCollapsed : ''}`}
            onClick={() => setDetailPanelCollapsed(!detailPanelCollapsed)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && setDetailPanelCollapsed(!detailPanelCollapsed)}
          >
            {detailPanelCollapsed ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
          </div>
          <DeviceDetailPanel
            device={devices[selectedDeviceId]}
            position={selectedPosition}
            onClose={() => dispatch(devicesActions.selectId(null))}
            onLocate={() => dispatch(devicesActions.selectId(selectedDeviceId))}
            onHistory={() => navigate(`/replay?deviceId=${selectedDeviceId}`)}
            onCommand={() => navigate(`/settings/device/${selectedDeviceId}/command`)}
            onEdit={() => navigate(`/settings/device/${selectedDeviceId}`)}
            onLockUnlock={handleLockUnlockClick}
            onAnchor={handleAnchorClick}
            onCamera={handleCameraClick}
            onDelete={handleDeleteClick}
            onDetails={() => selectedPosition && navigate(`/position/${selectedPosition.id}`)}
            onShare={() => navigate(`/settings/device/${selectedDeviceId}/share`)}
            onGeofence={handleGeofence}
            cameraLoading={cameraLoading}
          />
        </div>
      )}

      {/* Dialogs for DeviceDetailPanel */}
      {selectedDeviceId && devices[selectedDeviceId] && (
        <>
          <AnchorDialog
            open={openAnchorDialog}
            onClose={() => setOpenAnchorDialog(false)}
            deviceName={devices[selectedDeviceId]?.name || 'Desconhecido'}
            position={selectedPosition}
            device={devices[selectedDeviceId]}
            dispatch={dispatch}
          />

          <RemoveAnchorDialog
            open={openRemoveAnchorDialog}
            onClose={() => setOpenRemoveAnchorDialog(false)}
            deviceName={devices[selectedDeviceId]?.name || 'Desconhecido'}
            device={devices[selectedDeviceId]}
            position={selectedPosition}
            dispatch={dispatch}
          />

          <LockUnlockConfirmationDialog
            open={openLockUnlockDialog}
            onClose={() => setOpenLockUnlockDialog(false)}
            onConfirm={executeLockUnlock}
            isBlocked={isBlocked}
            deviceName={devices[selectedDeviceId]?.name || 'Desconhecido'}
            loading={commandLoading}
          />

          <RemoveDialog
            open={openRemoveDialog}
            endpoint="devices"
            itemId={selectedDeviceId}
            onResult={handleRemoveResult}
          />
        </>
      )}

      <SuccessToast
        open={showSuccessToast}
        message={toastMessage}
        severity={toastSeverity}
        onClose={() => setShowSuccessToast(false)}
      />

    </div>
  )
}

export default MainPage
